import { useState } from "react";
import { useResetOnChange } from "@/lib/hooks/use-reset-on-change";

/**
 * Resets local override whenever the parent's `collapsed` value changes so a
 * child group can participate in a parent "collapse all / expand all" toggle
 * while still allowing independent toggling afterward.
 */
export function useGroupCollapse(
  parentCollapsed: boolean,
): [boolean, () => void] {
  const [localOverride, setLocalOverride] = useState<boolean | null>(null);

  useResetOnChange(parentCollapsed, () => setLocalOverride(null));

  const isCollapsed = localOverride ?? parentCollapsed;
  const toggle = () =>
    setLocalOverride((prev) => !(prev ?? parentCollapsed));

  return [isCollapsed, toggle];
}
